import { getUserCouponHistory } from "@/api/history-api"
import i18n from '@/helper/i18n'
const history = {
  namespaced: true,
  state: {
    history: [],
    remainingExpirePoint: null
  },
  getters: {
    allHistoryList(state) {
      if (!state.history) return [];
      return state.history;
    },
    earnHistoryList(state) {
      return state.history.filter(e => e.points > 0)
    },
    burnHistoryList(state) {
      return state.history.filter(e => e.points < 0)
    },
    remainingExpirePoint(state) {
      return state.remainingExpirePoint
    },
  },
  mutations: {
    SET_HISTORY_LIST(state, historyList) {
      state.history = historyList
    },
    SET_REMAINING_EXPIRE_POINT(state, payload) {
      state.remainingExpirePoint = payload
    }
  },
  actions: {
    async fetchHistoryList({ commit }) {
      return await getUserCouponHistory(i18n.locale)
        .then(async (result) => {
          await commit("SET_HISTORY_LIST", result.data.data.historyPoint);
          if (result.data.data.expirePoint) {
            await commit("SET_REMAINING_EXPIRE_POINT", result.data.data.expirePoint);
          }
          return result.data.data.historyPoint;
        })
        .catch((err) => {
          throw err;
        });
    }
  }
}

export default history